// Test IDs for the DigitalOcean Spaces Management Panel.
export const NAV = {
    dashboardLink: 'nav-dashboard-link',
    spacesLink: 'nav-spaces-link',
    usersLink: 'nav-users-link',
    assignmentsLink: 'nav-assignments-link',
    themeToggle: 'nav-theme-toggle',
    userMenu: 'nav-user-menu',
    logoutButton: 'nav-logout-button',
    changePasswordButton: 'nav-change-password-button',
};

export const DASHBOARD = {
    root: 'dashboard-root',
    metricUsers: 'metric-users',
    metricSpaces: 'metric-spaces',
    metricStorage: 'metric-storage',
    metricFiles: 'metric-files',
    userSpaceCard: (id) => `user-space-card-${id}`,
};

export const SPACES = {
    root: 'spaces-root',
    createButton: 'space-create-button',
    createDialog: 'space-create-dialog',
    formName: 'space-form-name',
    formRegion: 'space-form-region',
    formEndpoint: 'space-form-endpoint',
    formBucket: 'space-form-bucket',
    formAccessKey: 'space-form-access-key',
    formSecretKey: 'space-form-secret-key',
    formCdnUrl: 'space-form-cdn-url',
    formStatus: 'space-form-status',
    formSubmit: 'space-form-submit',
    formTest: 'space-form-test',
    row: (id) => `space-row-${id}`,
    rowEdit: (id) => `space-row-edit-${id}`,
    rowDelete: (id) => `space-row-delete-${id}`,
    rowTest: (id) => `space-row-test-${id}`,
    rowRefresh: (id) => `space-row-refresh-${id}`,
    rowOpen: (id) => `space-row-open-${id}`,
};

export const USERS = {
    root: 'users-root',
    createButton: 'user-create-button',
    formName: 'user-form-name',
    formEmail: 'user-form-email',
    formPassword: 'user-form-password',
    formRole: 'user-form-role',
    formStatus: 'user-form-status',
    formSubmit: 'user-form-submit',
    row: (id) => `user-row-${id}`,
    rowEdit: (id) => `user-row-edit-${id}`,
    rowDelete: (id) => `user-row-delete-${id}`,
    rowReset: (id) => `user-row-reset-${id}`,
};

export const ASSIGN = {
    root: 'assignments-root',
    userSelect: 'assign-user-select',
    spaceCheckbox: (id) => `assign-space-${id}`,
    submit: 'assign-submit',
    remove: (userId, spaceId) => `assign-remove-${userId}-${spaceId}`,
};

export const EXPLORER = {
    root: 'explorer-root',
    breadcrumb: 'explorer-breadcrumb',
    searchInput: 'explorer-search-input',
    folder: (name) => `explorer-folder-${name}`,
    fileRow: (idx) => `explorer-file-row-${idx}`,
    previewButton: (idx) => `explorer-preview-${idx}`,
    copyUrlButton: (idx) => `explorer-copy-url-${idx}`,
    previewDialog: 'explorer-preview-dialog',
    closePreview: 'explorer-preview-close',
    selectRow: (idx) => `explorer-select-${idx}`,
    selectAll: 'explorer-select-all',
    copyToButton: 'explorer-copy-to-button',
    clearSelection: 'explorer-clear-selection',
    copyDialog: 'explorer-copy-dialog',
    copyDestSpace: 'explorer-copy-dest-space',
    copyDestPrefix: 'explorer-copy-dest-prefix',
    copyStart: 'explorer-copy-start',
    deleteRow: (idx) => `explorer-delete-${idx}`,
    bulkDelete: 'explorer-bulk-delete',
    deleteConfirm: 'explorer-delete-confirm',
};

export const JOBS = {
    root: 'jobs-root',
    navLink: 'nav-jobs-link',
    row: (id) => `job-row-${id}`,
    delete: (id) => `job-delete-${id}`,
};

export const DROPLETS = {
    root: 'droplets-root',
    navLink: 'nav-droplets-link',
    assignNavLink: 'nav-droplet-assignments-link',
    addButton: 'droplet-add-button',
    formDropletId: 'droplet-form-do-id',
    formToken: 'droplet-form-token',
    formLabel: 'droplet-form-label',
    formPassword: 'droplet-form-password',
    formSubmit: 'droplet-form-submit',
    row: (id) => `droplet-row-${id}`,
    rowOpen: (id) => `droplet-row-open-${id}`,
    rowEdit: (id) => `droplet-row-edit-${id}`,
    rowDelete: (id) => `droplet-row-delete-${id}`,
    rowRefresh: (id) => `droplet-row-refresh-${id}`,
    detailRoot: 'droplet-detail-root',
    refreshButton: 'droplet-refresh-button',
    resizeButton: 'droplet-resize-button',
    powerOnButton: 'droplet-power-on-button',
    resizeDialog: 'droplet-resize-dialog',
    resizeOption: (slug) => `droplet-resize-option-${slug}`,
    resizeConfirm: 'droplet-resize-confirm',
    passwordReveal: 'droplet-password-reveal',
    passwordCopy: 'droplet-password-copy',
    passwordValue: 'droplet-password-value',
};

export const DROPLET_ASSIGN = {
    root: 'droplet-assignments-root',
    userSelect: 'droplet-assign-user-select',
    checkbox: (id) => `droplet-assign-${id}`,
    submit: 'droplet-assign-submit',
    remove: (u, d) => `droplet-assign-remove-${u}-${d}`,
};

export const AUTH = {
    login: {
        emailInput: 'login-email-input',
        passwordInput: 'login-password-input',
        rememberInput: 'login-remember-input',
        submitButton: 'login-submit-button',
        forgotLink: 'login-forgot-link',
        errorText: 'login-error-text',
    },
    forgot: {
        emailInput: 'forgot-email-input',
        submitButton: 'forgot-submit-button',
        backLink: 'forgot-back-link',
    },
    reset: {
        passwordInput: 'reset-password-input',
        confirmInput: 'reset-confirm-input',
        submitButton: 'reset-submit-button',
    },
    change: {
        currentInput: 'change-current-input',
        newInput: 'change-new-input',
        submitButton: 'change-submit-button',
    },
};
